export default __webpack_public_path__ + "images/be6130196402964e521c44c2341e3d1d-hiking_small.webp";